
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/new",
      function () {
        return require("private-next-pages/game/new.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/new"])
      });
    }
  